import { render, staticRenderFns } from "./CustomTextArea.vue?vue&type=template&id=d8138f1e&scoped=true"
import script from "./CustomTextArea.vue?vue&type=script&lang=js"
export * from "./CustomTextArea.vue?vue&type=script&lang=js"
import style0 from "./CustomTextArea.vue?vue&type=style&index=0&id=d8138f1e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8138f1e",
  null
  
)

export default component.exports